import React, { useEffect, useState } from "react";
import CIcon from "@coreui/icons-react";
import { cilTv, cilList, cilCalendar, cilVideo } from "@coreui/icons";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import "./Sidebar.css";

const Sidebar = () => {
  const [user, setUser] = useState({});
  const [workspaces, setWorkspaces] = useState([]);
  const [selectedWorkspace, setSelectedWorkspace] = useState("");

  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    // Listen for user login state
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const userDoc = await getDoc(doc(db, "users", currentUser.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setUser({
            username: userData.username || "Guest",
            role: userData.role || "user",
          });
          setWorkspaces(userData.workspaces || []);
          setSelectedWorkspace(userData.workspaces[0] || "No Workspace Available");
        }
      } else {
        setUser({ username: "Guest" });
      }
    });

    return () => unsubscribe(); // Cleanup listener
  }, [auth, db]);

  const handleWorkspaceChange = (event) => {
    setSelectedWorkspace(event.target.value);
    // Handle workspace change logic here
  };

  return (
    <div className="sidebar-container">
      {/* Logo Section */}
      <div className="sidebar-logo">
        <Link to="/welcome">
          <img src={logo} alt="Logo" className="sidebar-logo-image" />
        </Link>
      </div>

      {/* User and Workspace Section */}
      <div className="sidebar-user-workspace">
        <p className="sidebar-username">{user.username}</p>
        {user.role === "admin" ? (
          <select
            className="sidebar-workspace-dropdown"
            value={selectedWorkspace}
            onChange={handleWorkspaceChange}
          >
            {workspaces.map((workspace, index) => (
              <option key={index} value={workspace}>
                {workspace}
              </option>
            ))}
          </select>
        ) : (
          <p className="sidebar-workspace">{selectedWorkspace}</p>
        )}
      </div>

      {/* Links Section */}
      <div className="sidebar-links">
        <Link to="/screens" className="sidebar-link">
          <CIcon icon={cilTv} size="md" className="sidebar-icon" />
          <span>Screens</span>
        </Link>
        <Link to="/content" className="sidebar-link">
          <CIcon icon={cilVideo} size="md" className="sidebar-icon" />
          <span>Content</span>
        </Link>
        <Link to="/playlists" className="sidebar-link">
          <CIcon icon={cilList} size="md" className="sidebar-icon" />
          <span>Playlists</span>
        </Link>
        <Link to="/schedules" className="sidebar-link">
          <CIcon icon={cilCalendar} size="md" className="sidebar-icon" />
          <span>Schedules</span>
        </Link>
      </div>

      {/* Footer Section */}
      <div className="sidebar-footer">
        <p>© {new Date().getFullYear()} Bizon.media</p>
      </div>
    </div>
  );
};

export default Sidebar;
